/* =============================================================================
   HUNDRED — theme script（Malletier / Sellier 共通。どちらのテーマも同じファイルを持つ）
   部品は data-* で見つけ、無ければ何もしない。
   ・重なるパネル：メニュー（段の掘り下げ data-sub-open）／検索／絞り込み／サイズ／カート
   ・一覧：data-layout="groups"（種類ごとの区画＋View More）か "flat"（5枚目ごとに大きく）
           絞り込み＝種類／プリント色／サイズ／在庫あり、並べ替え。?type=T-Shirts で開く
   ・カード内の写真スワイプ（data-card-gal）、写真の横送り（data-carousel）
   ・商品ページ：サイズ選択はシート、未選択では入らない、説明の続きを読む、上の小さな購入バー
   ・カート：Shopify AJAX Cart API でドロワーを更新
   ・お気に入り：この端末だけ（localStorage。使えなければ見た目だけ）
   ・ページ遷移：黒地に金のロゴを一瞬挟む（オーナー要件。CSSだけで必ず消える）
   JSが無くても、商品ページのフォームは通常の送信でカートに入る。
   ============================================================================= */
(function () {
  'use strict';
  const H = window.HUNDRED || {};
  const routes = H.routes || { cartAdd: '/cart/add', cart: '/cart', cartChange: '/cart/change' };
  const root = document.documentElement;
  const $$ = (sel, el) => [...(el || document).querySelectorAll(sel)];

  function money(cents) {
    const fmt = H.moneyFormat || '${{amount}}';
    const n = cents / 100;
    const two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const none = Math.round(n).toLocaleString('en-US');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, none)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1'))
      .replace(/\{\{\s*amount\s*\}\}/, two);
  }

  /* ---------- 重なるパネル ---------- */
  const stack = [];
  function openLayer(el, focusSel) {
    if (!el || el.classList.contains('is-open')) return;
    stack.push({ el, back: document.activeElement });
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    root.classList.add('is-locked');
    const f = el.querySelector(focusSel || 'button, a, input');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 40);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    const i = stack.findIndex(s => s.el === el);
    const back = i >= 0 ? stack.splice(i, 1)[0].back : null;
    if (!stack.length) root.classList.remove('is-locked');
    if (back && back.focus) back.focus({ preventScroll: true });
  }

  const menu = document.querySelector('[data-menu]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const drawer = document.getElementById('CartDrawer');

  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-menu-open]')) {
      openLayer(menu, '[data-menu-close]');
      $$('[data-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    } else if (t.closest('[data-menu-close]')) {
      closeLayer(menu);
      $$('[data-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (menu) menu.removeAttribute('data-level');
    } else if (t.closest('[data-sub-open]')) {
      // メニューの段を掘り下げる（LV型：「Shop」→ 種類の一覧）
      const id = t.closest('[data-sub-open]').dataset.subOpen;
      $$('[data-sub]', menu).forEach(s => { s.hidden = s.dataset.sub !== id; });
      menu.setAttribute('data-level', '2');
      const back = menu.querySelector(`[data-sub="${id}"] [data-sub-back]`);
      if (back) back.focus({ preventScroll: true });
    } else if (t.closest('[data-sub-back]')) {
      menu.removeAttribute('data-level');
    } else if (t.closest('[data-search-open]')) {
      if (menu && menu.classList.contains('is-open')) closeLayer(menu);
      openLayer(searchPanel, 'input[type="search"]');
    } else if (t.closest('[data-search-close]') || t === searchPanel) {
      closeLayer(searchPanel);
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && stack.length) closeLayer(stack[stack.length - 1].el);
  });

  /* ---------- ヘッダー：実寸を --header-h に／スクロールで状態を変える ---------- */
  const headerEl = document.querySelector('[data-header]');
  if (headerEl) {
    const setH = () => root.style.setProperty('--header-h', headerEl.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(headerEl);
    else addEventListener('resize', setH);
    let ticking = false;
    const onScroll = () => { ticking = false; root.classList.toggle('is-scrolled', scrollY > 24); };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ---------- プリント色（metafield custom.accent）を色相の群に ---------- */
  const HUE_GROUPS = [
    ['Red', '#C8342F', [[345, 360], [0, 14]]],
    ['Orange', '#D1600E', [[15, 42]]],
    ['Yellow', '#CF9B28', [[43, 62]]],
    ['Green', '#60A940', [[63, 160]]],
    ['Blue', '#1545AB', [[161, 255]]],
    ['Purple', '#5B2180', [[256, 300]]],
    ['Pink', '#D14F9B', [[301, 344]]],
    ['Black & White', '#1A1A1A', null]
  ];
  function hueOf(hex) {
    if (!/^#?[0-9a-f]{6}$/i.test(hex || '')) return 'Black & White';
    hex = hex.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16) / 255, g = parseInt(hex.slice(2, 4), 16) / 255, b = parseInt(hex.slice(4, 6), 16) / 255;
    const mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    if (d < 0.12 || mx < 0.3) return 'Black & White';
    let h = mx === r ? 60 * (((g - b) / d) % 6) : mx === g ? 60 * ((b - r) / d + 2) : 60 * ((r - g) / d + 4);
    if (h < 0) h += 360;
    for (const [name, , ranges] of HUE_GROUPS) if (ranges && ranges.some(([a, z]) => h >= a && h <= z)) return name;
    return 'Black & White';
  }

  /* ---------- 一覧 ---------- */
  function initShop(shop) {
    const cards = $$('[data-product]', shop);
    if (!cards.length) return;
    const layout = shop.dataset.layout || 'flat';
    const perGroup = +(shop.dataset.perGroup || 8);
    const DEFAULTS = { type: 'all', size: 'all', hue: 'all', stock: 'all', sort: 'featured' };
    const state = Object.assign({}, DEFAULTS);
    const expanded = new Set();
    cards.forEach(c => { c.dataset.hue = hueOf(c.dataset.accent); });

    // 実在する色だけを選択肢に（件数つき）
    const huesEl = shop.querySelector('[data-hues]');
    if (huesEl) {
      const count = {};
      cards.forEach(c => { count[c.dataset.hue] = (count[c.dataset.hue] || 0) + 1; });
      const tpl = huesEl.dataset.tpl || 'card';
      huesEl.innerHTML = HUE_GROUPS.filter(([n]) => count[n]).map(([n, col]) => tpl === 'swatch'
        ? `<button type="button" class="swatch" data-filter="hue:${n}" aria-pressed="false"><i style="background:${col}"></i><span>${n} (${count[n]})</span></button>`
        : `<button type="button" class="colour" data-filter="hue:${n}" aria-pressed="false"><i style="background:${col}"></i><span>${n}</span></button>`).join('');
    }

    const want = new URLSearchParams(location.search).get('type');
    if (want) {
      const hit = cards.find(c => c.dataset.type.toLowerCase() === want.toLowerCase());
      if (hit) state.type = hit.dataset.type;
    }

    const sheet = shop.querySelector('[data-sheet]');
    const title = c => (c.querySelector('[data-name]') || c).textContent.trim();
    const matches = c => (state.type === 'all' || c.dataset.type === state.type) &&
      (state.hue === 'all' || c.dataset.hue === state.hue) &&
      (state.size === 'all' || c.dataset.sizes.includes('|' + state.size + '|')) &&
      (state.stock === 'all' || +c.dataset.avail > 0);
    const sorter = (a, b) => {
      if (state.sort === 'az') return title(a).localeCompare(title(b));
      if (state.sort === 'type') return a.dataset.type.localeCompare(b.dataset.type) || (+a.dataset.order - +b.dataset.order);
      if (state.sort === 'stock') return (+b.dataset.avail - +a.dataset.avail) || (+a.dataset.order - +b.dataset.order);
      return +a.dataset.order - +b.dataset.order;
    };

    function apply() {
      let total = 0;
      if (layout === 'groups') {
        $$('[data-group]', shop).forEach(g => {
          const grid = g.querySelector('[data-group-grid]');
          const list = $$('[data-product]', grid).sort(sorter);
          list.forEach(c => grid.appendChild(c));
          const hit = list.filter(matches);
          const show = state.type !== 'all' || expanded.has(g.dataset.group) ? hit.length : perGroup;
          list.forEach(c => { c.hidden = true; });
          hit.forEach((c, i) => { c.hidden = i >= show; });
          total += hit.length;
          g.hidden = !hit.length || (state.type !== 'all' && g.dataset.group !== state.type);
          const more = g.querySelector('[data-more]');
          if (more) more.hidden = hit.length <= show;
        });
      } else {
        const grid = shop.querySelector('[data-grid]');
        const list = cards.slice().sort(sorter);
        list.forEach(c => grid.appendChild(c));
        let i = 0;
        list.forEach(c => {
          const ok = matches(c);
          c.hidden = !ok;
          c.classList.remove('is-wide');
          if (ok) { i++; if (i % 5 === 0) c.classList.add('is-wide'); }   // エルメス型：4枚ごとに1枚大きく
        });
        total = i;
      }
      $$('[data-count]', shop).forEach(el => { el.textContent = el.dataset.count === 'n' ? total : `${total} ${total === 1 ? 'product' : 'products'}`; });
      const empty = shop.querySelector('[data-empty]');
      if (empty) empty.hidden = total !== 0;
      const n = ['type', 'size', 'hue', 'stock'].filter(k => state[k] !== 'all').length;
      $$('[data-active-n]', shop).forEach(el => { el.hidden = !n; el.textContent = n; });
      $$('[data-filter]', shop).forEach(b => {
        const i = b.dataset.filter.indexOf(':');
        b.setAttribute('aria-pressed', String(state[b.dataset.filter.slice(0, i)] === b.dataset.filter.slice(i + 1)));
      });
      $$('[data-toggle]', shop).forEach(b => b.setAttribute('aria-checked', String(state[b.dataset.toggle] !== 'all')));
      const on = shop.querySelector('[data-tabs] [aria-pressed="true"]');
      if (on) on.parentElement.scrollTo({ left: Math.max(0, on.offsetLeft - 24), behavior: 'smooth' });
    }

    shop.addEventListener('click', e => {
      const f = e.target.closest('[data-filter]');
      if (f) {
        const i = f.dataset.filter.indexOf(':');
        const k = f.dataset.filter.slice(0, i), v = f.dataset.filter.slice(i + 1);
        state[k] = state[k] === v && k !== 'type' && k !== 'sort' ? 'all' : v;   // 同じ色・サイズをもう一度押すと解除
        if (f.closest('[data-tabs]')) scrollTo({ top: Math.min(scrollY, shop.offsetTop - 60), behavior: 'smooth' });
        apply();
        return;
      }
      const tg = e.target.closest('[data-toggle]');
      if (tg) { const k = tg.dataset.toggle; state[k] = state[k] === 'all' ? 'yes' : 'all'; apply(); return; }
      const more = e.target.closest('button[data-more]');
      if (more) { expanded.add(more.closest('[data-group]').dataset.group); apply(); return; }
      if (e.target.closest('[data-clear]')) { Object.assign(state, DEFAULTS, { sort: state.sort }); apply(); return; }
      if (e.target.closest('[data-sheet-open]')) openLayer(sheet, '[data-sheet-close]');
      else if (e.target.closest('[data-sheet-close]')) closeLayer(sheet);
    });
    apply();
  }

  /* ---------- 写真の横送り（エルメス型の「01 / 06」） ---------- */
  function initCarousel(el) {
    const track = el.querySelector('[data-carousel-track]');
    const n = el.querySelector('[data-carousel-n]');
    if (!track) return;
    const slides = [...track.children];
    const current = () => {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0, d = Infinity;
      slides.forEach((s, i) => { const c = s.offsetLeft + s.offsetWidth / 2; if (Math.abs(c - mid) < d) { d = Math.abs(c - mid); best = i; } });
      return best;
    };
    const go = i => {
      const s = slides[Math.max(0, Math.min(slides.length - 1, i))];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
    };
    track.addEventListener('scroll', () => { if (n) n.textContent = String(current() + 1).padStart(2, '0'); }, { passive: true });
    $$('[data-carousel-step]', el).forEach(b => b.addEventListener('click', () => go(current() + +b.dataset.carouselStep)));
  }

  /* ---------- カード・商品写真の横スワイプに合わせて点を動かす ---------- */
  function initSwipeDots(gal) {
    const dots = $$('i', gal.parentElement.querySelector('[data-dots]') || document.createElement('i'));
    const n = gal.parentElement.querySelector('[data-gal-n]');
    gal.addEventListener('scroll', () => {
      const i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
      if (n) n.textContent = String(i + 1).padStart(2, '0');
    }, { passive: true });
    $$('[data-gal-step]', gal.parentElement).forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      gal.scrollBy({ left: gal.clientWidth * +b.dataset.galStep, behavior: 'smooth' });
    }));
  }

  /* ---------- 横に流れる商品列：細いバーで位置を示す ---------- */
  function initRail(rail) {
    const track = rail.querySelector('[data-rail-track]');
    const thumb = rail.querySelector('[data-rail-thumb]');
    if (!track || !thumb) return;
    const upd = () => {
      const max = track.scrollWidth - track.clientWidth;
      const w = Math.max((track.scrollWidth ? track.clientWidth / track.scrollWidth : 1) * 100, 12);
      thumb.style.width = w + '%';
      thumb.style.transform = `translateX(${(max > 0 ? track.scrollLeft / max : 0) * (100 - w) / w * 100}%)`;
      rail.classList.toggle('is-static', max <= 1);
    };
    track.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd);
    upd();
  }

  /* ---------- お気に入り（この端末だけ） ---------- */
  const WKEY = 'hundred:saved';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { saved = []; }
  const paintWish = () => $$('[data-wish]').forEach(b => b.setAttribute('aria-pressed', String(saved.includes(b.dataset.wish))));
  document.addEventListener('click', e => {
    const w = e.target.closest('[data-wish]');
    if (!w) return;
    e.preventDefault();
    const h = w.dataset.wish;
    saved = saved.includes(h) ? saved.filter(x => x !== h) : saved.concat(h);
    try { localStorage.setItem(WKEY, JSON.stringify(saved)); } catch (err) { /* 保存できない環境では見た目だけ */ }
    paintWish();
  });

  /* ---------- カート ---------- */
  const body = drawer && drawer.querySelector('[data-drawer-body]');
  const foot = drawer && drawer.querySelector('[data-drawer-foot]');
  const emptyText = body ? (body.textContent.trim() || 'Your bag is empty.') : '';

  async function renderCart(open) {
    const res = await fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.toggleAttribute('data-empty', !cart.item_count); });
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = `<p class="drawer__empty">${emptyText}</p>`;
        if (foot) foot.hidden = true;
      } else {
        body.innerHTML = cart.items.map((it, i) => {
          const img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=300' : '';
          const size = it.variant_title && it.variant_title !== 'Default Title' ? `<div class="line__meta">${it.variant_title}</div>` : '';
          return `<div class="line">
            <a class="line__img" href="${it.url}">${img ? `<img src="${img}" alt="">` : ''}</a>
            <div class="line__info">
              <a class="line__title" href="${it.url}">${it.product_title}</a>${size}
              <div class="line__qty">
                <button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button>
                <span>${it.quantity}</span>
                <button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button>
              </div>
            </div>
            <div class="line__price">${money(it.final_line_price)}</div>
          </div>`;
        }).join('');
        if (foot) {
          foot.hidden = false;
          const t = foot.querySelector('[data-cart-total]');
          if (t) t.textContent = money(cart.total_price);
        }
      }
    }
    if (open) openLayer(drawer, '[data-drawer-close]');
    return cart;
  }

  async function addToCart(id, qty) {
    const res = await fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to bag');
    }
    return renderCart(true);
  }

  document.addEventListener('click', async e => {
    if (e.target.closest('[data-cart-open]') && drawer) { e.preventDefault(); renderCart(true); return; }
    if (e.target.closest('[data-drawer-close]')) { closeLayer(drawer); return; }
    const q = e.target.closest('[data-line][data-qty]');
    if (q) {
      await fetch(routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(q.dataset.line), quantity: Math.max(0, Number(q.dataset.qty)) })
      });
      renderCart(false);
    }
  });

  /* ---------- 商品ページ ---------- */
  function initProduct(page) {
    const form = page.querySelector('#ProductForm');
    const input = page.querySelector('[data-variant-input]');
    const addBtn = page.querySelector('[data-add]');
    const err = page.querySelector('[data-size-error]');
    const label = page.querySelector('[data-size-label]');
    const sheet = page.querySelector('[data-size-sheet]');
    const sizes = $$('[data-size-sheet] [data-variant]', page);
    const optName = label ? label.dataset.option || 'Size' : 'Size';

    page.addEventListener('click', e => {
      if (e.target.closest('[data-size-open]')) openLayer(sheet, '[data-variant]:not([disabled])');
      else if (e.target.closest('[data-size-close]')) closeLayer(sheet);
      const rm = e.target.closest('[data-readmore]');
      if (rm) {
        const box = page.querySelector('[data-clamp]');
        const open = box.classList.toggle('is-open');
        rm.textContent = open ? rm.dataset.less : rm.dataset.more;
      }
    });

    sizes.forEach(btn => btn.addEventListener('click', () => {
      if (btn.disabled) return;
      sizes.forEach(b => { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-checked', String(b === btn)); });
      input.value = btn.dataset.variant;
      if (err) err.hidden = true;
      if (label) { label.textContent = (label.dataset.prefix ? optName + ': ' : '') + btn.dataset.title; label.classList.add('is-set'); }
      if (btn.dataset.price) $$('[data-price]', page).forEach(p => { p.textContent = btn.dataset.price; });
      const url = new URL(location.href);
      url.searchParams.set('variant', btn.dataset.variant);
      history.replaceState(null, '', url);
      closeLayer(sheet);
    }));

    async function submit() {
      if (sizes.length && !input.value) {
        if (err) err.hidden = false;
        openLayer(sheet, '[data-variant]:not([disabled])');
        return;
      }
      $$('[data-add], [data-bar-add]', page).forEach(b => b.setAttribute('aria-busy', 'true'));
      try { await addToCart(input.value, 1); }
      catch (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } }
      finally { $$('[data-add], [data-bar-add]', page).forEach(b => b.removeAttribute('aria-busy')); }
    }
    if (form) form.addEventListener('submit', e => { e.preventDefault(); submit(); });
    $$('[data-bar-add]', page).forEach(b => b.addEventListener('click', submit));

    // LV型：主ボタンが画面の上へ抜けたら、ヘッダー下に「名前・価格・小さなボタン」の帯を出す
    const bar = page.querySelector('[data-pdp-bar]');
    const anchor = page.querySelector('[data-cta]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', String(!show));
      }, { rootMargin: '-60px 0px 0px 0px' }).observe(anchor);
    }
  }

  $$('[data-shop]').forEach(initShop);
  $$('[data-carousel]').forEach(initCarousel);
  $$('[data-card-gal], [data-gal]').forEach(initSwipeDots);
  $$('[data-rail]').forEach(initRail);
  $$('[data-product-page]').forEach(initProduct);
  paintWish();

  // PCではフッターの開閉を全部開いた状態にする
  const wide = matchMedia('(min-width: 990px)');
  const syncFoot = () => $$('.site-footer details').forEach(d => { d.open = wide.matches; });
  syncFoot();
  if (wide.addEventListener) wide.addEventListener('change', syncFoot);
})();

/* ---- ページ遷移ロゴ演出（オーナー要件）：クリック時に一瞬見せてから遷移する ----
   到着時の表示→消えるはCSSアニメーションだけで完結するので、このJSが無くても必ず消える。 */
(function () {
  const overlay = document.querySelector('[data-page-transition]');
  if (!overlay) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function isEligible(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.hasAttribute('data-cart-open')) return false;
    let url;
    try { url = new URL(a.href, location.href); } catch (e) { return false; }
    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    return true;
  }
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a');
    if (!isEligible(a)) return;
    e.preventDefault();
    // 次のページに着いたときも同じ色で続けるため、ここで色を決めて渡す
    if (window.hundredPickPair) {
      const pair = window.hundredPickPair();
      window.hundredApplyPair(pair);
      try { sessionStorage.setItem('hundredPT', JSON.stringify(pair)); } catch (err) {}
    }
    overlay.classList.remove('is-intro');
    overlay.classList.add('is-active');
    const go = () => { location.href = a.href; };
    if (reduce) go(); else setTimeout(go, 110);
  });
  addEventListener('pageshow', e => {
    if (!e.persisted) return;
    overlay.classList.remove('is-active');
    overlay.style.animation = 'none';
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
  });
})();
